export const iconFontAwesomeReligionKhanda = (
	<i className="fa-solid fa-khanda"></i>
);
